import { isClientClient } from '__core/shared/util/salestrekker';
import template from './allianzButton.template.html';
import templateRefer from './allianz.template.html';

export default {
  template,
  bindings: {
    ticketClientTypes: '<',
    contacts: '<',
    idTicket: '<',
    isDisabled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $timeout, $mdDialog, allianzService, dateTimeService, ALLIANZ) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.destroyWatch = null;

      ctrl.initialize = () => {
        ctrl.ticketClientTypes = ctrl.ticketClientTypes || [];
        ctrl.contacts = _.filter(
          ctrl.contacts || [],
          (c) => !c?.isCompany && isClientClient(ctrl.ticketClientTypes, c?.id)
        );
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.isDisabled = ctrl.isDisabled || false;
      };

      ctrl.openDialog = ($event) => {
        $event.stopPropagation();
        $mdDialog.show({
          targetEvent: $event,
          locals: {
            contacts: ctrl.contacts || [],
            idTicket: ctrl.idTicket || '',
            isDisabled: ctrl.isDisabled || false
          },
          template: templateRefer,
          controllerAs: '$ctrl',
          multiple: true,
          controller(contacts, idTicket, isDisabled) {
            const self = this;
            self.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
            self.organization = $rootScope.CurrentOrganization;
            self.contacts = contacts;
            self.idTicket = idTicket;
            self.isDisabled = isDisabled;
            self.hours = ALLIANZ.QUESTIONS.HOURS;
            self.allianzModel = {
              idInsuredContact: '',
              idCoInsuredContacts: [],
              preferredContactDate: '',
              preferredInsuredContactTime: '',
              preferredCoInsuredContactTime: [],
              buildingRequested: false,
              contentsRequested: false,
              landlordRequested: false,
              motorRequested: false,
              caravanRequestedFlag: false,
              comments: '',
              consent: false
            };
            self.errorMessages = [];
            self.hasError = false;
            self.isSubmitted = false;
            self.isSending = false;
            self.isLoading = false;

            self.toggleCoInsuredContacts = () => {
              const len = self.allianzModel?.idCoInsuredContacts?.length || 0;
              for (let i = 0; i < len; i += 1) {
                const idCoInsuredContact = self.allianzModel?.idCoInsuredContacts[i];
                const preferredCoInsuredContact = _.find(
                  self.allianzModel?.preferredCoInsuredContactTime || [],
                  (p) => p?.idContact === idCoInsuredContact
                );
                if (!preferredCoInsuredContact) {
                  self.allianzModel.preferredCoInsuredContactTime.push({
                    idContact: idCoInsuredContact,
                    time: ''
                  });
                }
              }
              const idContacts = _.map(
                self.allianzModel?.preferredCoInsuredContactTime || [],
                'idContact'
              );
              const diff = _.difference(
                idContacts,
                self.allianzModel?.idCoInsuredContacts || []
              );
              const dLen = diff?.length || 0;
              for (let d = 0; d < dLen; d += 1) {
                const idx = _.findIndex(
                  self.allianzModel?.preferredCoInsuredContactTime,
                  (i) => i?.idContact === diff[d]
                );
                if (idx > -1) {
                  self.allianzModel?.preferredCoInsuredContactTime.splice(idx, 1);
                }
              }
            };

            dateTimeService.getSet(
              self,
              self.allianzModel,
              'preferredContactDate',
              'getSetPreferredContactDate'
            );

            self.isDateInThePast = () => {
              const contactDateTime = _.isNumber(self.allianzModel.preferredContactDate)
                ? self.allianzModel.preferredContactDate
                : dateTimeService.epoch(self.allianzModel.preferredContactDate);
              const isDateInThePast = dateTimeService
                .getMoment(contactDateTime)
                .endOf('day')
                .isBefore(dateTimeService.getMoment(dateTimeService.epoch()));

              if (isDateInThePast) {
                if (!self.hasError) {
                  self.hasError = true;
                  self.errorMessages.push(
                    'Allianz errors:',
                    'The preferred contact date is in the past.'
                  );
                }
              } else if (!self.isSending) {
                self.hasError = false;
                self.errorMessages = [];
              }
              return isDateInThePast;
            };

            self.canSelect = ({ idContact, type }) => {
              if (type === 'insured') {
                return _.indexOf(self.allianzModel.idCoInsuredContacts, idContact) > -1;
              }
              return idContact === self.allianzModel.idInsuredContact;
            };

            self.hasOnePreferredProductSelected = () =>
              self.allianzModel?.buildingRequested ||
              self.allianzModel?.contentsRequested ||
              self.allianzModel?.landlordRequested ||
              self.allianzModel?.motorRequested ||
              self.allianzModel?.caravanRequestedFlag;

            self.canSend = () => {
              if (
                !self.hasOnePreferredProductSelected() ||
                !self.allianzModel?.consent ||
                !self.allianzModel?.idInsuredContact ||
                self.isDateInThePast() ||
                (self.allianzModel?.preferredContactDate !== '' &&
                  self.allianzModel?.preferredInsuredContactTime === '') ||
                (self.allianzModel?.idCoInsuredContacts?.length &&
                  self.allianzModel?.preferredContactDate !== '' &&
                  _.every(
                    self.allianzModel?.preferredCoInsuredContactTime || [],
                    (p) => p?.time === ''
                  ))
              ) {
                return false;
              }

              return !self.isDisabled;
            };

            self.getContactName = ({ idContact }) => {
              const contact = _.find(self.contacts || [], (c) => c?.id === idContact);
              return contact?.getName() || 'N/A';
            };

            self.confirm = () => {
              if (self.canSend()) {
                self.errorMessages = [];
                self.hasError = false;
                self.isLoading = true;
                self.isSending = false;
                self.isSubmitted = false;
                allianzService
                  .refer({
                    idTicket: self.idTicket,
                    allianzDetails: self.allianzModel
                  })
                  .then((result) => {
                    self.isSending = true;
                    self.isLoading = false;
                    if (result?.status) {
                      self.isSubmitted = true;
                      $timeout(() => {
                        $mdDialog.hide();
                      }, 5000);
                    } else {
                      self.hasError = true;
                      if (result?.errors?.length) {
                        const len = result?.errors?.length || 0;
                        for (let e = 0; e < len; e += 1) {
                          const error = result?.errors[e];
                          const message = error?.label
                            ? `${error?.label?.sanitize()} -> ${error?.message || ''}`
                            : error?.message || error || '';
                          self.errorMessages.push(message);
                        }
                      } else {
                        self.errorMessages.push(result?.errorMessage);
                      }
                      self.errorMessages.unshift('Allianz errors:');
                    }
                  });
              }
            };

            self.cancel = () => {
              $mdDialog.cancel();
            };
          }
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        if (ctrl.destroyWatch) {
          ctrl.destroyWatch();
        }
      };
    }
  }
};
